import { render, staticRenderFns } from "./ModalCartExpired.vue?vue&type=template&id=0535e192"
import script from "./ModalCartExpired.vue?vue&type=script&lang=js"
export * from "./ModalCartExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports